import Vue from 'vue'
import { Logger } from '../composition/Logger'

let html, noScrollClasses

Vue.directive('modal-window', {
  inserted: () => {
    try {
      const scrollbarWidth =
        window.innerWidth - document.documentElement.clientWidth
      html = document.querySelector('html')
      noScrollClasses = [
        'no-scroll',
        !!scrollbarWidth && 'no-scroll--shift-compensation',
      ]
      for (const cls of noScrollClasses) {
        html.classList.add(cls)
      }
    } catch (e) {
      Logger.error('Cannot add class no-scroll', e)
    }
  },
  unbind: () => {
    for (const cls of noScrollClasses) {
      html.classList.remove(cls)
    }
  },
})

Vue.directive('viewport-height', {
  bind: (el, binding) => {
    binding.setHeight = () => {
      el.style.setProperty('height', `${window.innerHeight}px`)
    }
    window.addEventListener('resize', binding.setHeight)
    binding.setHeight()
  },
  unbind: (_el, binding) => {
    window.removeEventListener('resize', binding.setHeight)
  },
})
